import { ElementRef, Pipe, PipeTransform, inject } from '@angular/core';
import { TranslationsService } from './translation.service';

interface TranslateParams {
  [key: string]: string | number;
}

@Pipe({
  name: 'translate'
})
export class TranslationPipe implements PipeTransform {
  private readonly elementRef = inject(ElementRef<HTMLElement>);

  readonly i18n_ATTRIBUTE = 'data-i18n';

  constructor(private translationService: TranslationsService) {}

  /**
   *
   * @param value
   * @param args
   * default: Default value to output if the value translated don't exist.
   *
   * params: values to replace the words like "\_key_" from text with the value attachaded to that key.
   * @param i18nSelector Points to a child element to add the i18n attribute. A case of use when a component
   * has attibute to translate but the translation is in a child element.
   * @returns
   */
  transform(
    value: string,
    args: { placeholder?: string; ignoreIfempty?: boolean; i18nSelector?: string; params?: TranslateParams } = {}
  ): string {
    const { params, ignoreIfempty, i18nSelector } = args;
    let { placeholder } = args;

    // Split the @@ to get the key and the default value
    if (value && value.includes('@@')) {
      const [key, defaultValue] = value.split('@@');
      value = key;
      placeholder = defaultValue;
    }

    if (ignoreIfempty && !value) return undefined;
    const translation = this.translationService.translate(value, placeholder, params);
    // ADD ATTRIBUTES TO ELEMENT - Comment cause hidratation issues in some cases
    // let attrTarget = this.elementRef.nativeElement;
    // // Detect if element is a HTMLElement or Text
    // if (this.elementRef.nativeElement.nodeType !== 1) {
    //   attrTarget = this.elementRef.nativeElement.parentElement;
    // } else if (i18nSelector) {
    //   attrTarget = this.elementRef.nativeElement.querySelector(i18nSelector);
    // }
    // attrTarget.setAttribute(this.i18n_ATTRIBUTE, value);
    // // Notify if is used a placeholder in case the key doesn't exist
    // if (placeholder && !this.translationService.keyExists(value)) {
    //   attrTarget.setAttribute(`${this.i18n_ATTRIBUTE}-placeholder-active`, 'true');
    // }
    /////////////////////////////

    return translation;
  }
}
